module.exports = __webpack_public_path__ + "DINNextLTPro-Medium.woff2?fd4853d390f73f04c56310b326f7db3f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-Medium.woff2
// module id = 1379
// module chunks = 0